import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useState, useEffect, useRef } from "react";

function LanguageDropdown() {
  const [open, setOpen] = useState(false);

  const [lang, setLang] = useState(() => {
    return localStorage.getItem("language") || "en";
  });

  const dropdownRef = useRef(null);

  // =========================================================
  // CLEAR GOOGLE TRANSLATE COOKIE
  // =========================================================

  const clearGoogleTranslateCookie = () => {
    const hostname = window.location.hostname;

    // Current path
    document.cookie =
      "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Current domain
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${hostname};`;

    // Parent domain
    if (hostname.split(".").length > 1) {
      const domain = "." + hostname.split(".").slice(-2).join(".");

      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
    }
  };

  // =========================================================
  // SET GOOGLE TRANSLATE COOKIE
  // =========================================================

  const setGoogleTranslateCookie = (language) => {
    document.cookie = `googtrans=/en/${language}; path=/;`;
  };

  // =========================================================
  // CHANGE LANGUAGE
  // =========================================================

  const changeLanguage = (language) => {
    if (language === lang) {
      setOpen(false);
      return;
    }

    // Close dropdown
    setOpen(false);

    // -------------------------------------------------------
    // SAVE LANGUAGE
    // -------------------------------------------------------

    localStorage.setItem("language", language);

    // Update React state
    setLang(language);

    // Tell other React components
    window.dispatchEvent(new Event("languageChanged"));

    // -------------------------------------------------------
    // CLEAR PREVIOUS GOOGLE TRANSLATE STATE
    // -------------------------------------------------------

    clearGoogleTranslateCookie();

    // -------------------------------------------------------
    // ENGLISH
    // -------------------------------------------------------

    if (language === "en") {
      // Make sure English is stored
      localStorage.setItem("language", "en");

      setTimeout(() => {
        window.location.reload();
      }, 100);

      return;
    }

    // -------------------------------------------------------
    // FRENCH / PORTUGUESE
    // -------------------------------------------------------

    setGoogleTranslateCookie(language);

    // Try to update Google Translate immediately
    const select = document.querySelector(".goog-te-combo");

    if (select) {
      select.value = language;

      select.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );
    }

    // Reload so Google Translate starts from English
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  // =========================================================
  // INITIAL LOAD
  // =========================================================

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";

    setLang(savedLanguage);

    // Set Google Translate cookie if required
    if (savedLanguage !== "en") {
      setGoogleTranslateCookie(savedLanguage);
    }

    // -------------------------------------------------------
    // CLOSE DROPDOWN WHEN CLICKING OUTSIDE
    // -------------------------------------------------------

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // =========================================================
  // LANGUAGE LABEL
  // =========================================================

  const getLanguageName = () => {
    switch (lang) {
      case "fr":
        return "FRA";

      case "pt":
        return "POR";

      case "en":
      default:
        return "EN";
    }
  };

  // =========================================================
  // JSX
  // =========================================================

  return (
    <div className="language-dropdown" ref={dropdownRef}>
      <button className="lang-btn" onClick={() => setOpen((prev) => !prev)}>
        <div className="d-flex align-items-center gap-1">
          <img src="/assets/globe.svg" alt="Language" className="lang-icon" />

          <span>{getLanguageName()}</span>
        </div>

        {open ? (
          <MdKeyboardArrowUp fontSize={20} />
        ) : (
          <MdKeyboardArrowDown fontSize={20} />
        )}
      </button>

      {open && (
        <ul className="lang-menu">
          <li onClick={() => changeLanguage("en")}>English</li>

          <li onClick={() => changeLanguage("fr")}>French</li>

          <li onClick={() => changeLanguage("pt")}>Portuguese</li>
        </ul>
      )}
    </div>
  );
}

export default LanguageDropdown;
